// import React, { useEffect, useState } from "react";
// import "./Instructions.css";
// import Start_Btn from "../../common/start-btn/Start_Btn";
// import { useDispatch, useSelector } from "react-redux";
// import { GetAllTest, startTest } from "../../../redux/test";
// import { Getprofile } from "../../../redux/profile";
// import TimerModal from "../../modals/timer-modal/TimerModal";
// import { useNavigate } from "react-router-dom";
// import Common_Btn from "../../common/common-btn/Common_Btn";
// import Login_Modal from "../../modals/login-modal/Login_Modal";

// const Instructions = () => {
//   const dispatch = useDispatch();
//   const [showModal, setShowModal] = useState(false);
//   const [showModalLogin, setShowModalLogin] = useState(false);
//   const [expanded, setExpanded] = useState(false);
//   const [isLoggedIn, setIsLoggedIn] = useState(false);

//   const navigate = useNavigate();

//   const getUserprofile = useSelector((state) => state?.profile?.getprofile);

//   const getAllExams = useSelector((state) => state?.test);

//   useEffect(() => {
//     dispatch(GetAllTest());
//     dispatch(Getprofile());
//   }, [dispatch]);

//   var HtmlToReactParser = require("html-to-react").Parser;
//   var htmlToReactParser = new HtmlToReactParser();

//   const onSubmit = async (id) => {
//     try {
//       const response = await dispatch(startTest({ id: id }));

//       if (response?.payload?.success) {
//         dispatch(GetAllTest());
//         setShowModal(true);
//         setTimeout(() => {
//           setShowModal(false);
//           navigate(`/test-page/${response?.payload?.data?.id}`);
//         }, 5000);
//       } else {
//       }
//     } catch (error) {
//       console.error(error);
//     }
//   };

//   return (
//     <>
//       <section className="Instructions_holder">
//         {getAllExams?.data?.map((d, index) => (
//           <div className="instruction_section">
//             <div className="timer_holder">
//               <h1 className="text_name">{d?.name}</h1>
//               <div className="timer">
//                 <h2 className="title_cyan">
//                   Time:{" "}
//                   <span className="time">
//                     <b>{d?.time} Minutes</b>
//                   </span>
//                 </h2>
//               </div>
//             </div>

//             <h2 className="title_cyan">Instructions!</h2>
//             <p className="description_text">
//               {htmlToReactParser.parse(d?.instructions)}
//             </p>

//             <hr className="custom_divider" />

//             <h3 className="title_red">TRY NOT TO THINK ABOUT:</h3>
//             {/* <ol className="description_text"> */}
//             <p className="description_text">
//               {htmlToReactParser.parse(d?.try_not_to)}
//             </p>
//             {/* </ol> */}

//             <hr className="custom_divider" />

//             <h3 className="title_green">POINTS TO REMEMBER:</h3>
//             {/* <ol className="description_text"> */}
//             <p className="description_text">
//               {htmlToReactParser.parse(d?.points_to_remember)}
//             </p>
//             {/* </ol> */}

//             {getUserprofile?.user?.accept_or_reject == true ? (
//               <div className="btn_div">
//                 <Start_Btn
//                   text="Start Test"
//                   onClick={() => {
//                     onSubmit(d?.id);
//                   }}
//                 />
//               </div>
//             ) : (
//               <p style={{ color: "red", textAlign: "right" }}>
//                 <Common_Btn
//                   text="Login"
//                   onClick={() => {
//                     setShowModalLogin(true);
//                     setExpanded(false);
//                   }}
//                 />
//               </p>
//             )}
//             {/* <div className="btn_div">
//               <Start_Btn text="Start Test" link="/test-page" />
//             </div> */}
//           </div>
//         ))}

//         <TimerModal
//           show={showModal}
//           handleClose={() => setShowModal(false)}
//           message={"Successful"}
//         />

//         <Login_Modal
//           show={showModalLogin}
//           handleClose={() => setShowModalLogin(false)}
//           handleLogin={() => setIsLoggedIn(true)}
//         />
//       </section>
//     </>
//   );
// };

// export default Instructions;

import React, { useCallback, useEffect, useRef, useState } from "react";
import "./Instructions.css";
import { Spinner } from "react-bootstrap";
import Start_Btn from "../../common/start-btn/Start_Btn";
import { useDispatch, useSelector } from "react-redux";
import { GetAllTest, startTest } from "../../../redux/test";
import { IDS } from "../../../utils/IDS";
import {
  GetAllUserTest,
  Getprofile,
  markTestAttended,
} from "../../../redux/profile";
import TimerModal from "../../modals/timer-modal/TimerModal";
import { useLocation, useNavigate } from "react-router-dom";
import Common_Btn from "../../common/common-btn/Common_Btn";
import Login_Modal from "../../modals/login-modal/Login_Modal";

const Instructions = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [showModalLogin, setShowModalLogin] = useState(false);
  const [testId, setTestId] = useState(null);
  const [startTestMsg, setStartTestMsg] = useState("");
  const [startTestMsgVisible, setStartTestMsgVisible] = useState(false);
  const startTestMsgTimeoutRef = useRef(null);

  const getUserprofile = useSelector((state) => state?.profile?.getprofile);
  
const SignIn = useSelector((state) => state?.auth?.login?.isLoggedIn);
  const getUserTest = useSelector((state) => state?.profile?.getTestData);

  const getAllExams = useSelector((state) => state?.test);

  // ✅ Loader flags for slow exam-list response
  // status can be undefined (pre-first-fetch) / idle / loading — all mean "waiting"
  const examsStatus = getAllExams?.status;
  const hasExams =
    Array.isArray(getAllExams?.data) && getAllExams.data.length > 0;
  const examsError = getAllExams?.error;
  const isExamsLoading =
    !hasExams &&
    examsStatus !== IDS.SLICESTATUS.Succeeded &&
    examsStatus !== IDS.SLICESTATUS.Failed;

  const location = useLocation();

  useEffect(() => {
    dispatch(GetAllTest());
    dispatch(Getprofile());
    dispatch(GetAllUserTest());
  }, [dispatch]);

  // ✅ Refetch attended list every time user lands / returns here
  useEffect(() => {
    dispatch(GetAllUserTest());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, location.pathname, location.key]);

  useEffect(() => {
    const onFocus = () => dispatch(GetAllUserTest());
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [dispatch]);

  // ✅ Cleanup start-test message timer on unmount
  useEffect(
    () => () => {
      if (startTestMsgTimeoutRef.current)
        clearTimeout(startTestMsgTimeoutRef.current);
    },
    []
  );

  const HtmlToReactParser = require("html-to-react").Parser;
  const htmlToReactParser = new HtmlToReactParser();

  const onSubmit = async (id) => {
    try {
      // ✅ Enter fullscreen
      if (!document.fullscreenElement) {
        try {
          await document.documentElement.requestFullscreen();
        } catch (err) {
          console.warn("Fullscreen blocked:", err);
        }
      }

      // ✅ Lock Escape key
      if (navigator.keyboard && navigator.keyboard.lock) {
        try {
          await navigator.keyboard.lock(["Escape"]);
        } catch (e) {
          console.warn("Keyboard lock failed", e);
        }
      }

      setTestId(id);
      setShowModal(true);
    } catch (error) {
      console.error(error);
    }
  };

  // ✅ After countdown — wrap in useCallback so TimerModal effect doesn't reset
  const startTestAfterCountdown = useCallback(async () => {
    const examId = testId; // capture — cancelTestCountdown clears testId
    if (!examId) return;

    try {
      const response = await dispatch(startTest({ id: examId }));
      const startedTestId = response?.payload?.data?.id;

      if (response?.payload?.success && startedTestId) {
        // ✅ Mark attended instantly — "Already Attended" shows without refresh
        dispatch(markTestAttended(examId));
        dispatch(GetAllUserTest());
        navigate(`/test-page/${startedTestId}`);
        return;
      }

      // ⚠️ startTest rejected — show server message (e.g. "User exam already exists")
      // and refresh the attended list so "Already Attended" appears without refresh.
      // Server body: {success:false, code:404, message:"Not Found", errors:"User exam already exists"}
      // Prefer `errors` (the specific reason), fall back to `message`.
      const serverMsg =
        response?.payload?.errors ||
        response?.payload?.message ||
        (typeof response?.payload === "string" ? response.payload : "") ||
        response?.error?.message ||
        "Failed to start test. Please try again.";
      // Hide the generic "Not Found" — the `errors` field carries the real reason
      const displayMsg =
        serverMsg === "Not Found" && response?.payload?.errors
          ? response.payload.errors
          : serverMsg;
      await cancelTestCountdown();
      setStartTestMsg(displayMsg);
      setStartTestMsgVisible(true);
      // ✅ Refresh attended list AFTER closing modal so "Already Attended" appears
      dispatch(markTestAttended(examId));
      try {
        await dispatch(GetAllUserTest());
      } catch (e) {
        console.error("Failed to refresh attended tests:", e);
      }
      if (startTestMsgTimeoutRef.current) clearTimeout(startTestMsgTimeoutRef.current);
      startTestMsgTimeoutRef.current = setTimeout(
        () => setStartTestMsgVisible(false),
        4000
      );
    } catch (error) {
      console.error(error);
      await cancelTestCountdown();
    }
  }, [dispatch, navigate, testId]);

  const cancelTestCountdown = useCallback(async () => {
    setShowModal(false);
    setTestId(null);
    navigator.keyboard?.unlock?.();

    if (document.fullscreenElement) {
      try {
        await document.exitFullscreen();
      } catch (error) {
        console.warn("Could not exit fullscreen:", error);
      }
    }
  }, []);

  // 🚫 Prevent tab switch
  // useEffect(() => {
  //   const handleVisibilityChange = () => {
  //     if (document.hidden) {
  //       alert("Tab switching is not allowed!");
  //     }
  //   };

  //   document.addEventListener("visibilitychange", handleVisibilityChange);
  //   return () => {
  //     document.removeEventListener("visibilitychange", handleVisibilityChange);
  //   };
  // }, []);

  // 🚫 Prevent exiting fullscreen
  // useEffect(() => {
  //   const handleFullscreenChange = () => {
  //     if (!document.fullscreenElement) {
  //       alert("Exiting fullscreen is not allowed!");
  //       document.documentElement.requestFullscreen();
  //     }
  //   };

  //   document.addEventListener("fullscreenchange", handleFullscreenChange);
  //   return () => {
  //     document.removeEventListener("fullscreenchange", handleFullscreenChange);
  //   };
  // }, []);

  // 🚫 Disable right click
  useEffect(() => {
    const handleRightClick = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handleRightClick);

    return () => {
      document.removeEventListener("contextmenu", handleRightClick);
    };
  }, []);

  // 🚫 Block keys
  useEffect(() => {
    const handleKeyDown = (e) => {
      // Block F1–F12
      if (e.keyCode >= 112 && e.keyCode <= 123) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Ctrl combinations
      if (e.ctrlKey) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Alt combinations (not 100% but helps)
      if (e.altKey) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block Escape
      if (e.key === "Escape") {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }

      // Block specific keys manually
      const blockedKeys = [
        "F1",
        "F2",
        "F3",
        "F4",
        "F5",
        "F6",
        "F7",
        "F8",
        "F9",
        "F10",
        "F11",
        "F12",
        "Alt",
        "Meta",
      ];

      if (blockedKeys.includes(e.key)) {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);

    return () => {
      window.removeEventListener("keydown", handleKeyDown, true);
    };
  }, []);

  useEffect(() => {
    const handleKeyUp = (e) => {
      if ((e.keyCode >= 112 && e.keyCode <= 123) || e.ctrlKey || e.altKey) {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    window.addEventListener("keyup", handleKeyUp, true);

    return () => {
      window.removeEventListener("keyup", handleKeyUp, true);
    };
  }, []);

  const user = getUserprofile?.user;

  const isLoggedIn = !!user;

  const isProfileComplete =
    user?.first_name &&
    user?.dob &&
    user?.email &&
    user?.contact_no &&
    user?.education_details &&
    user?.occupation;

  // ✅ Attended check — tolerant of exam_id / examId / id / test_id shapes
  const isAttended = (examList, examCardId) => {
    if (!Array.isArray(examList)) return false;
    const target = Number(examCardId);
    if (Number.isNaN(target)) return false;
    return examList.some((item) => {
      if (item == null) return false;
      if (typeof item === "number" || typeof item === "string") {
        return Number(item) === target;
      }
      const candidates = [
        item?.exam_id,
        item?.examId,
        item?.examID,
        item?.test_id,
        item?.testId,
        item?.id,
        item?.exam?.id,
        item?.Exam?.id,
      ];
      return candidates.some((c) => c !== undefined && c !== null && Number(c) === target);
    });
  };

  return (
    <>
      <section className="Instructions_holder">
        {startTestMsgVisible && startTestMsg ? (
          <div className="alert alert-warning text-center" role="alert">
            {startTestMsg}
          </div>
        ) : null}
        {isExamsLoading && !hasExams ? (
          <div
            className="d-flex flex-column align-items-center justify-content-center py-5"
            role="status"
            aria-live="polite"
          >
            <Spinner animation="border" role="status">
              <span className="visually-hidden">
                Loading test instructions...
              </span>
            </Spinner>
            <p className="mt-3 mb-0">Loading test instructions...</p>
          </div>
        ) : examsError && !hasExams ? (
          <div className="text-center py-5" role="alert">
            <p className="text-danger mb-3">
              {typeof examsError === "string"
                ? examsError
                : "Failed to load test instructions. Please try again."}
            </p>
            <Start_Btn
              text="Retry"
              onClick={() => {
                dispatch(GetAllTest());
                dispatch(GetAllUserTest());
              }}
            />
          </div>
        ) : !hasExams ? (
          <div className="text-center py-5">
            <p className="text-muted mb-0">No tests available right now.</p>
          </div>
        ) : (
          getAllExams?.data?.map((d) => (
          <div className="instruction_section" key={d.id}>
            <div className="timer_holder">
              <h1 className="text_name">{d?.Test_Type?.name}</h1>
              <div className="timer">
                <h2 className="title_cyan">
                  Time:{" "}
                  <span className="time">
                    <b>{d?.time} Minutes</b>
                  </span>
                </h2>
              </div>
            </div>

            <h2 className="title_cyan">Instructions!</h2>
            <p className="description_text">
              {htmlToReactParser.parse(d?.instructions)}
            </p>

            <hr className="custom_divider" />

            <h3 className="title_red">TRY NOT TO THINK ABOUT:</h3>
            <p className="description_text">
              {htmlToReactParser.parse(d?.try_not_to)}
            </p>

            <hr className="custom_divider" />

            <h3 className="title_green">POINTS TO REMEMBER:</h3>
            <p className="description_text">
              {htmlToReactParser.parse(d?.points_to_remember)}
            </p>

            {/* {getUserprofile?.user?.accept_or_reject === true ? (
              <div className="btn_div">
                <Start_Btn text="Start Test" onClick={() => onSubmit(d?.id)} />
              </div>
            ) : (
              <p style={{ color: "red", textAlign: "right" }}>
                <Common_Btn
                  text="Please Login"
                  onClick={() => setShowModalLogin(true)}
                />
              </p>
            )} */}

            {!SignIn ? (
              // ❌ NOT LOGGED IN
              <p style={{ color: "red", textAlign: "right" }}>
                <Common_Btn
                  text="Please Login"
                  onClick={() => setShowModalLogin(true)}
                />
              </p>
            ) : !isProfileComplete ? (
              // ⚠️ PROFILE NOT UPDATED
              <p style={{ color: "orange", textAlign: "right" }}>
                <Common_Btn
                  text="Please Update Profile"
                  onClick={() => navigate("/profile")} // ✅ PROFILE PAGE
                />
              </p>
            ) : isAttended(getUserTest, d?.id) ? (
              // ⚠️ ALREADY ATTENDED
              <p style={{ color: "#f59e0b", textAlign: "right" }}>
                <Common_Btn text="Already Attended" />
              </p>
            ) : (
              // ✅ READY TO START TEST
              <div className="btn_div">
                <Start_Btn text="Start Test" onClick={() => onSubmit(d?.id)} />
              </div>
            )}
          </div>
          ))
        )}

        <TimerModal
          show={showModal}
          handleClose={() => setShowModal(false)}
          onCancel={cancelTestCountdown}
          onCountdownFinish={startTestAfterCountdown}
        />

        <Login_Modal
          show={showModalLogin}
          handleClose={() => setShowModalLogin(false)}
        />
      </section>
    </>
  );
};

export default Instructions;
